import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { accountsApi, type AccountsListParams } from '@/api/accounts';
import { accountKeys } from '@/lib/queryKeys';
import { GC_TIMES, STALE_TIMES } from '@/lib/constants';

export function useAccounts(params: AccountsListParams = {}) {
  return useQuery({
    queryKey: accountKeys.list(params),
    queryFn: () => accountsApi.list(params),
    staleTime: STALE_TIMES.medium,
    gcTime: GC_TIMES.default,
    placeholderData: keepPreviousData,
  });
}

export function useAccount(id: string | undefined) {
  return useQuery({
    queryKey: accountKeys.detail(id ?? ''),
    queryFn: () => accountsApi.get(id!),
    enabled: !!id,
    staleTime: STALE_TIMES.medium,
    gcTime: GC_TIMES.long,
  });
}
